import { Component, Directive, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '.tooltip-container',
  standalone: false,
})
export class TooltipContainerDirective {}

@Component({
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  standalone: false,
})
export class TooltipComponent implements OnInit, OnDestroy {
  top: string;
  @ViewChild(TooltipContainerDirective, { read: ElementRef, static: true }) private tooltipContainer;

  constructor(@Inject('tooltipConfig') private config) {}

  ngOnInit() {
    const { top } = this.config.host.getBoundingClientRect();
    const { height } = this.tooltipContainer.nativeElement.getBoundingClientRect();
    this.top = `${top - height}px`;
  }

  ngOnDestroy() {
    this.tooltipContainer = null;
  }
}
